export const MuiFab = {
    styleOverrides: {
        root: ({ theme })=>({
                backgroundColor: theme.palette.background.default,
                border: `1px solid ${theme.palette.text.secondary}`,
                color: theme.palette.text.secondary,
                '&:hover': {
                    backgroundColor: 'inherit'
                }
            })
    }
};

//# sourceMappingURL=fab.js.map